'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.serialize = serialize;
exports.delay = delay;
exports.parseQuery = parseQuery;
exports.addQueryString = addQueryString;
function serialize(obj) {
    var s = [];
    /* eslint-disable no-useless-escape */
    var rbracket = /\[\]$/;
    /* eslint-enable */

    var add = function add(k, v) {
        v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
        s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
    };
    var buildParams = function buildParams(prefix, obj) {
        var i = void 0,
            len = void 0,
            key = void 0;

        if (prefix) {
            if (Array.isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    if (rbracket.test(prefix)) {
                        add(prefix, obj[i]);
                    } else {
                        buildParams(prefix + '[' + (_typeof(obj[i]) === 'object' ? i : '') + ']', obj[i]);
                    }
                }
            } else if (obj && String(obj) === '[object Object]') {
                for (key in obj) {
                    buildParams(prefix + '[' + key + ']', obj[key]);
                }
            } else {
                add(prefix, obj);
            }
            // } else if (Array.isArray(obj)) {
            //     for (i = 0, len = obj.length; i < len; i++) {
            //         add(obj[i].name, obj[i].value);
            //     }
        } else {
            if (obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
                for (key in obj) {
                    buildParams(key, obj[key]);
                }
            }
        }
        return s;
    };

    return buildParams('', obj).join('&');
}

function delay(time) {
    return new Promise(function (resolve) {
        return setTimeout(resolve, time);
    });
}

function parseQuery(query) {
    if (typeof query !== 'string') return query;
    var reg = /([^=&\s]+)[=\s]*([^=&\s]*)/g;
    var obj = {};
    while (reg.exec(query)) {
        obj[RegExp.$1] = decodeURIComponent(RegExp.$2);
    }
    return obj;
}

function addQueryString(url, qs) {
    if (!qs) {
        return url;
    }

    var connector = url.indexOf('?') > -1 ? '&' : '?';
    return '' + url + connector + qs;
}

var isWeex = exports.isWeex = typeof callNative === 'function';
var isWeb = exports.isWeb = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && _typeof(window.document) === 'object';
var isNodejs = exports.isNodejs = (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';